/**
 * @generated SignedSource<<78a61aff8944210567429c22d827c045>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Cleanliness = "BAD" | "GREAT" | "MEDIUM" | "%future added value";
export type CustomerSatisfaction = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type JobTypes = "INSTALLATION" | "INSTALLATION_FOLLOW_UP" | "SAMPLE_EVENT" | "SITE_VISIT" | "%future added value";
export type StaffEnthusiasm = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type Status = "COMPLETED" | "IN_PROCESS" | "ON_HOLD" | "PENDING" | "%future added value";
export type StatusOfSanitizer = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type TrafficRate = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type ViewJob_getLogJobQuery$variables = {
  id: string;
};
export type ViewJob_getLogJobQuery$data = {
  readonly getLogJob: {
    readonly actionItems: string | null;
    readonly actionNoteCategoryId: string | null;
    readonly additionalComments: string | null;
    readonly additionalNoteCategoryId: string | null;
    readonly attachments: any | null;
    readonly cleanliness: Cleanliness | null;
    readonly closingDateAndTime: string | null;
    readonly createdBy: {
      readonly firstName: string;
      readonly id: string;
    } | null;
    readonly customerSatisfaction: CustomerSatisfaction | null;
    readonly dateAndTime: string;
    readonly id: string;
    readonly jobType: JobTypes;
    readonly location: {
      readonly id: string;
      readonly name: string;
      readonly servicePlan: {
        readonly id: string;
        readonly indicater: string | null;
      } | null;
      readonly uuid: string | null;
    } | null;
    readonly locationId: string;
    readonly machineChecks: ReadonlyArray<{
      readonly blenderName: string | null;
      readonly checksDetail: any | null;
      readonly cupHolderName: string | null;
      readonly locationId: string | null;
      readonly machineId: string | null;
      readonly machineName: string | null;
      readonly serialNumber: string | null;
      readonly tubeShieldName: string | null;
    }> | null;
    readonly machineName: string | null;
    readonly machineSerialNumber: string | null;
    readonly marketingMaterials: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly operations: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly sanitizerStatus: StatusOfSanitizer | null;
    readonly staffEnthusiasm: StaffEnthusiasm | null;
    readonly status: Status;
    readonly tickets: ReadonlyArray<{
      readonly diagnosisDone: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }> | null;
      readonly id: string;
      readonly issuesReported: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }> | null;
      readonly machine: {
        readonly id: string;
        readonly name: string | null;
        readonly serialNumber: string;
      } | null;
      readonly machineServicesDone: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }> | null;
      readonly reportedAt: string | null;
      readonly uuid: string | null;
    }> | null;
    readonly trafficRate: TrafficRate | null;
    readonly travelTime: number | null;
    readonly travelingEndTime: any | null;
    readonly travelingStartTime: any | null;
    readonly uploadImagesOrVideos: ReadonlyArray<{
      readonly type: string | null;
      readonly url: string | null;
    }> | null;
    readonly uuid: string | null;
    readonly workStartTime: any | null;
  };
};
export type ViewJob_getLogJobQuery = {
  response: ViewJob_getLogJobQuery$data;
  variables: ViewJob_getLogJobQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "machineName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serialNumber",
  "storageKey": null
},
v7 = [
  (v1/*: any*/),
  (v4/*: any*/)
],
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "LogJobsObjectType",
    "kind": "LinkedField",
    "name": "getLogJob",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobType",
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalNoteCategoryId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionNoteCategoryId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LocationObjectType",
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ServicePlanObjectType",
            "kind": "LinkedField",
            "name": "servicePlan",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "indicater",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dateAndTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "attachments",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LogJobMachineCheckObjectType",
        "kind": "LinkedField",
        "name": "machineChecks",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "machineId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "checksDetail",
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "blenderName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tubeShieldName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cupHolderName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TicketObjectType",
        "kind": "LinkedField",
        "name": "tickets",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reportedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MachineObjectType",
            "kind": "LinkedField",
            "name": "machine",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueReportedObjectType",
            "kind": "LinkedField",
            "name": "issuesReported",
            "plural": true,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DiagnosisObjectType",
            "kind": "LinkedField",
            "name": "diagnosisDone",
            "plural": true,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MachineServiceObjectType",
            "kind": "LinkedField",
            "name": "machineServicesDone",
            "plural": true,
            "selections": (v7/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "OperationObjectType",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": (v7/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MediaDto",
        "kind": "LinkedField",
        "name": "uploadImagesOrVideos",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MarketingMaterialsObjectType",
        "kind": "LinkedField",
        "name": "marketingMaterials",
        "plural": true,
        "selections": (v7/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sanitizerStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "machineSerialNumber",
        "storageKey": null
      },
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalComments",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionItems",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerSatisfaction",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cleanliness",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "trafficRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "staffEnthusiasm",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "closingDateAndTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "travelTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "travelingStartTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "travelingEndTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workStartTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserObjectType",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewJob_getLogJobQuery",
    "selections": (v8/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewJob_getLogJobQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "f5446939443095e9abe5a28abb1c2281",
    "id": null,
    "metadata": {},
    "name": "ViewJob_getLogJobQuery",
    "operationKind": "query",
    "text": "query ViewJob_getLogJobQuery(\n  $id: String!\n) {\n  getLogJob(id: $id) {\n    id\n    uuid\n    jobType\n    locationId\n    additionalNoteCategoryId\n    actionNoteCategoryId\n    location {\n      id\n      uuid\n      name\n      servicePlan {\n        id\n        indicater\n      }\n    }\n    dateAndTime\n    attachments\n    machineChecks {\n      locationId\n      machineId\n      checksDetail\n      machineName\n      serialNumber\n      blenderName\n      tubeShieldName\n      cupHolderName\n    }\n    tickets {\n      id\n      uuid\n      reportedAt\n      machine {\n        id\n        name\n        serialNumber\n      }\n      issuesReported {\n        id\n        name\n      }\n      diagnosisDone {\n        id\n        name\n      }\n      machineServicesDone {\n        id\n        name\n      }\n    }\n    operations {\n      id\n      name\n    }\n    uploadImagesOrVideos {\n      url\n      type\n    }\n    marketingMaterials {\n      id\n      name\n    }\n    sanitizerStatus\n    machineSerialNumber\n    machineName\n    additionalComments\n    actionItems\n    customerSatisfaction\n    cleanliness\n    trafficRate\n    staffEnthusiasm\n    status\n    closingDateAndTime\n    travelTime\n    travelingStartTime\n    travelingEndTime\n    workStartTime\n    createdBy {\n      id\n      firstName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "71c3319e81c25eb37e8260cfdebc6201";

export default node;
